import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from '@singularsystems/neo-react';
import MissingExchangeRateCombinationsReportCriteria from './MissingExchangeRateCombinationsReportCriteria';
import { TextConstants } from '../../../Common/TextConstants';
import { AppService, Types } from '../../../App/Services/AppService';



@NeoReport("MissingExchangeRateCombinations", { category: MaintenanceReportCategories.DataEnrichmentReports })
export default class MissingExchangeRateCombinationsReport extends Report<MissingExchangeRateCombinationsReportCriteria> {

    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(MissingExchangeRateCombinationsReportCriteria);
    }

    public renderCriteria() {
        return (
            <>
                <Neo.GridLayout lg={3} md={3}>
                    <Neo.FormGroup
                        bindContext={this.criteria.meta.serviceProviderName}
                        label={TextConstants.Labels.ServiceProvider}>
                        <Neo.AutoCompleteDropDown
                            itemSource={this.serviceProviderApiClient.getServiceProviderListByCriteria}
                            bind={this.criteria.meta.staticServiceProviderId}
                            bindDisplay={this.criteria.meta.serviceProviderName}
                            displayMember={"serviceProviderName"}
                            items={this.serviceProviderApiClient.getServiceProviderListByCriteria(" ").then((arr) => arr.data.slice(0, 10)
                                .sort((x, y) => x.serviceProviderName.localeCompare(y.serviceProviderName)))} />
                    </Neo.FormGroup>
                </Neo.GridLayout>
            </>
        );
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}